const ITEMS = [
  "Découvrez votre signature olfactive",
  "Le luxe du sillage, à prix accessible",
  "Une sélection raffinée pour elle et pour lui",
  "Des senteurs qui habillent la peau",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic text-ivory/90 sm:text-2xl">{t}</span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-champagne" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-champagne/20 bg-espresso py-6">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </section>
);
